//Template showing a list of uploaded images/files (thumbnails)
import React from "react"
import { ImagePreview } from "./ImagePreview"

const UploadedImageList = ({uploadErrors,  uploadedImages, setUploadedImages, uploadProgress, handleRemoveImage }) => {
  return (
    <>
      {uploadErrors && ( <p className={`upload-errors`}>{uploadErrors}</p>)}
      <>
        {(uploadedImages.length > 0 || uploadProgress) && (
          <>
          <p>Files uploaded</p>
          <ul className={`uploaded-image-list`}>
            {uploadedImages.map((uploadedImage, i) => {
              return <ImagePreview key={i} id={uploadedImage.info.id} file={uploadedImage.file} name={uploadedImage.file.name} onRemoveImage={handleRemoveImage} />
            })}
            {uploadProgress && <ImagePreview key={`in-progress`} name={uploadProgress.name} uploadProgress={uploadProgress.progress} />}
          </ul>
          </>
        )}
      </>
    </>
  )
}

export default UploadedImageList
